import React, { FC } from 'react';
import Helmet from 'react-helmet';
import { CDN_ORIGIN_ENDPOINT } from '../../../../../shared/cdn';

export const HeadFavicon: FC = () => (
  <Helmet>
    <link
      id="favicon"
      rel="icon"
      href={`${CDN_ORIGIN_ENDPOINT}/img/logo/logos_doctrine/favicon/favicon.png`}
      type="image/png"
    />
    <link
      id="favicon_32"
      rel="icon"
      href={`${CDN_ORIGIN_ENDPOINT}/img/logo/logos_doctrine/favicon/favicon_32.png`}
      sizes="32x32"
      type="image/png"
    />
    <link
      id="favicon_96"
      rel="icon"
      href={`${CDN_ORIGIN_ENDPOINT}/img/logo/logos_doctrine/favicon/favicon_96.png`}
      sizes="96x96"
      type="image/png"
    />
    <link
      rel="apple-touch-icon"
      href={`${CDN_ORIGIN_ENDPOINT}/img/logo/logos_doctrine/favicon/favicon_180.png`}
      sizes="180x180"
      type="image/png"
    />
    <link
      rel="image_src"
      href={`${CDN_ORIGIN_ENDPOINT}/img/logo/logos_doctrine/banner.png`}
    />
  </Helmet>
);
